import { render, staticRenderFns } from "./DmPreislisten.vue?vue&type=template&id=c3e464d6&scoped=true&"
import script from "./DmPreislisten.vue?vue&type=script&lang=js&"
export * from "./DmPreislisten.vue?vue&type=script&lang=js&"
import style0 from "./DmPreislisten.vue?vue&type=style&index=0&id=c3e464d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e464d6",
  null
  
)

export default component.exports